import React, { useState } from "react";
import {
  Layout,
  Menu,
  Drawer,
  Button,
  Grid,
  Card,
  List,
  Tooltip,
  Avatar,
  Typography,
  Input,
  Divider,
} from "antd";
import {
  ArrowLeftOutlined,
  DownloadOutlined,
  EditOutlined,
  EllipsisOutlined,
  HomeOutlined,
  InfoCircleOutlined,
  MenuOutlined,
  NumberOutlined,
  PaperClipOutlined,
  SearchOutlined,
  SendOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import "./adminchat.css";
const { useBreakpoint } = Grid;
const { Sider, Content, Header, Footer } = Layout;
const { Text, Title } = Typography;
const AdminChats = () => {
  const [drawerVisible, setDrawerVisible] = useState(false);
  const screens = useBreakpoint();
  const [selectedChat, setSelectedChat] = useState(null);
  const [showInfo, setShowInfo] = useState(false);
  const [message, setMessage] = useState("");
  const [userDrawer, setUserDrawer] = useState(false);
  const navigate = useNavigate();

  const channels = [
    {
      id: 1,
      name: "#General",
      lastMessage: "Check incident log",
      time: "10:42 AM",
    },
    {
      id: 2,
      name: "Data Analysis",
      lastMessage: "Report uploaded",
      time: "9:15 AM",
    },
    {
      id: 3,
      name: "Support Department",
      lastMessage: "Ticket resolved",
      time: "8:20 AM",
    },
  ];

  const users = [
    {
      id: 4,
      name: "Guest1",
      lastMessage: "Check incident log",
      time: "10:42 AM",
    },
    { id: 5, name: "Guest2", lastMessage: "Report uploaded", time: "9:15 AM" },
    { id: 6, name: "Guest3", lastMessage: "Ticket resolved", time: "8:20 AM" },
    { id: 7, name: "Guest4", lastMessage: "Ticket resolved", time: "8:20 AM" },
    { id: 8, name: "Guest5", lastMessage: "Ticket resolved", time: "8:20 AM" },
    { id: 9, name: "Guest6", lastMessage: "Ticket resolved", time: "8:20 AM" },
  ];

  const messages = [
    {
      id: 1,
      sender: "guest-1234",
      text: "Anna wants to connect.",
      time: "2:00 PM",
    },
    {
      id: 2,
      sender: "mahmoud",
      text: "Hello! Welcome to Dubai Chambers chat assistance. How may I help you today?",
      time: "2:00 PM",
    },
    {
      id: 3,
      sender: "guest-1234",
      text: "Hello there, do you prefer to chat with Arabic? I have an Arabic college here or it's ok in English.",
      time: "2:01 PM",
    },
    {
      id: 4,
      sender: "mahmoud",
      text: "I can chat in English or Arabic. Whichever suits you.",
      time: "2:02 PM",
    },
    {
      id: 5,
      sender: "guest-1234",
      text: "Ok nice, I prefer English.\n\nDear Sir,\n\nGreetings, I would like to inquire about a company named Musk Dubai for perfumes and cosmetics.",
      time: "2:03 PM",
    },
  ];

  const drawerContent = (
    <div
      className={`bg-[#000437] h-full w-full md:w-64 flex-shrink-0 flex flex-col transition-all duration-300`}
    >
      <Header className="bg-[#000437]  px-4 border-b border-gray-700">
        <div className="flex items-center justify-between">
          <div>
            <Avatar className="bg-blue-600 ">A</Avatar>
          </div>
          <div className="flex  items-center gap-4 text-sm">
            <Tooltip title="Home">
              <HomeOutlined className="text-white" />
            </Tooltip>
            <Tooltip title="Search">
              <SearchOutlined className="text-white" />
            </Tooltip>
            <Tooltip title="Channels">
              <NumberOutlined className="text-white" />
            </Tooltip>
            <Tooltip title="Downloads">
              <DownloadOutlined className="text-white" />
            </Tooltip>
            <Tooltip title="Compose">
              <EditOutlined className="text-white" />
            </Tooltip>
            <Tooltip title="More">
              <EllipsisOutlined className="text-white" />
            </Tooltip>
          </div>
        </div>
      </Header>

      <div className="bg-[#000437] flex items-center justify-between px-4 border-b border-gray-700">
        <div className="flex items-center gap-2 py-2">
          {/* <Button
            type="text"
            icon={<ArrowLeftOutlined className="text-gray-300" />}
            className="text-gray-300 md:hidden"
            onClick={() => navigate("/react-dashboard")}
          /> */}
          <Text className="text-gray-100 font-semibold text-lg">
            Admin IPC
          </Text>
        </div>
        {/* <Button type="text" icon={<MenuOutlined className="text-gray-300" />} /> */}
      </div>

      <div className="p-3">
        <Input
          prefix={<SearchOutlined className="text-gray-400" />}
          placeholder="Search teams..."
          className="rounded-md text-black border-none"
        />
      </div>

      <div className="sidebar-scroll flex-1 overflow-y-auto ">
        <div className="px-3">
          <span className="text-gray-200 text-[12px]">Queued chats</span>
        </div>
        <List
          itemLayout="horizontal"
          dataSource={users}
          renderItem={(item, idx) => (
            <List.Item
              className={`hover:bg-[#003366] rounded-md cursor-pointer mb-1  transition ${
                selectedChat?.id === item.id ? "bg-[#003366]" : ""
              }`}
              onClick={() => {
                setSelectedChat(item);
                setDrawerVisible(false);
              }}
            >
              <List.Item.Meta
                avatar={<Avatar className="ml-2">{item.name.charAt(0)}</Avatar>}
                title={
                  <span className="text-gray-100 font-medium">{item.name}</span>
                }
                // description={<span className="text-gray-400 text-sm">{item.lastMessage}</span>}
              />
            </List.Item>
          )}
        />
        <div className="px-3">
          <span className="text-gray-200 text-[12px]">Channels</span>
        </div>
        <List
          itemLayout="horizontal"
          dataSource={channels}
          renderItem={(item, idx) => (
            <List.Item
              className={`hover:bg-[#003366] rounded-md cursor-pointer mb-1 p-2 transition ${
                selectedChat?.id === item.id ? "bg-[#003366]" : ""
              }`}
              onClick={() => setSelectedChat(item)}
            >
              <List.Item.Meta
                avatar={
                  <Avatar className="ml-2">
                    {idx == 0 ? item.name.charAt(1) : item.name.charAt(0)}
                  </Avatar>
                }
                title={
                  <span className="text-gray-100 font-medium">{item.name}</span>
                }
                description={
                  <span className="text-gray-400 text-sm">
                    {item.lastMessage}
                  </span>
                }
              />
            </List.Item>
          )}
        />
      </div>
    </div>
  );

  const drawerUserInfo = (
    <div
      className={`bg-white w-full h-full border-l border-gray-300 flex flex-col transition-all duration-300`}
      style={{
        height: "100vh", 
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Header */}
      <Header className="flex items-center justify-between px-4 py-3 border-b border-gray-300 bg-[#f1f5f9] flex-shrink-0">
        <Text className="font-semibold text-gray-900 text-lg">
          Room Information
        </Text>
        <Button
          type="text"
          className="text-gray-300 md:hidden"
          icon={<ArrowLeftOutlined className="text-gray-300" />}
          onClick={() => setUserDrawer(false)}
        />
      </Header>

      {/* Scrollable content */}
      <div
        className="p-5 space-y-5 text-gray-700 flex-1 overflow-y-auto"
        style={{
          height: "calc(100vh - 64px)", 
        }}
      >
        <div>
          <Text className="text-gray-900 font-semibold block mb-1">
            Contact
          </Text>
          <div className="flex items-center gap-2">
            <Avatar>A</Avatar>
            <Text>Anna (guest-1234)</Text>
          </div>
        </div>

        <Divider />

        <div>
          <Text className="text-gray-900 font-semibold block mb-1">Agent</Text>
          <div className="flex items-center gap-2">
            <Avatar>M</Avatar>
            <div>
              <Text className="block text-gray-800">Maani (mahmoud)</Text>
              <Text className="block text-gray-500 text-sm">
                Department: DC_AGENT_EN
              </Text>
            </div>
          </div>
        </div>
        <Divider />

        {/* Details */}
        <div>
          <Text className="block text-gray-500 text-sm">Queue Time</Text>
          <Text className="text-gray-800">A few seconds</Text>
        </div>

        <div>
          <Text className="block text-gray-500 text-sm">Created At</Text>
          <Text className="text-gray-800">July 8, 2025, 2:00 PM</Text>
        </div>

        <div>
          <Text className="block text-gray-500 text-sm">Taken At</Text>
          <Text className="text-gray-800">July 8, 2025, 2:00 PM</Text>
        </div>
      </div>
    </div>
  );

  return (
    <Layout style={{ height: "100vh", overflow: "hidden" }}>
      {" "}
      {!screens.md && (
        <Drawer
          placement="left"
          closable={false}
          onClose={() => setDrawerVisible(false)}
          open={drawerVisible}
          bodyStyle={{
            padding: 0,
            height: "100%",
            background: "#001529",
          }}
          headerStyle={{ display: "none" }} // Removes header completely
        >
          {drawerContent}
        </Drawer>
      )}
      {screens.md && (
        <Sider
          width={260}
          style={{
            background: "#001529",
            color: "#fff",
            height: "100vh",
            overflow: "hidden",
          }}
        >
          {drawerContent}
        </Sider>
      )}
      <Layout style={{ overflow: "hidden" }}>
        {" "}
        <Content
          style={{
            background: "#f5f5f5",
            display: "flex",
            flexDirection: "column",
            height: "100vh", // full height
            overflow: "hidden", // no full scroll
          }}
        >
          {/* Chat Header */}
          <Header className="bg-[#f1f5f9] flex items-center justify-between px-4 border-b border-gray-300 flex-shrink-0">
            <div className="flex items-center gap-3">
              <Button
                className="flex md:hidden"
                type="text"
                icon={<MenuOutlined />}
                onClick={() => setDrawerVisible(true)}
              />

              <Text className="text-black text-lg font-semibold">
                {selectedChat ? selectedChat.name : ""}
              </Text>
            </div>
            {selectedChat && (
              <Button
                type="text"
                icon={<InfoCircleOutlined className="text-gray-900" />}
                className="md:hidden"
                onClick={() => setUserDrawer(true)}
              />
            )}
          </Header>

          {/* 👇 Scrollable only here */}
          <div
            className="flex-1 overflow-y-auto p-6 space-y-5 bg-[#f1f5f9]"
            style={{ scrollbarWidth: "thin" }}
          >
            {selectedChat ? (
              <>
                <div className="text-center text-gray-500 text-sm font-medium mt-2">
                  Start of conversation
                  <br />
                  <span className="text-xs">July 8, 2025</span>
                </div>

                {messages.map((msg) => (
                  <div key={msg.id} className="space-y-1">
                    <div className="flex items-center justify-between">
                      <Text className="text-gray-700 font-medium capitalize">
                        {msg.sender}
                      </Text>
                      <Text className="text-gray-500 text-xs">{msg.time}</Text>
                    </div>
                    <div className="bg-white shadow-sm border border-gray-200 p-3 rounded-lg whitespace-pre-line text-gray-700">
                      {msg.text}
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <div className="h-full flex items-center justify-center text-gray-400">
                Select a conversation from the left panel
              </div>
            )}
          </div>

          {/* Message Input */}
          {selectedChat && (
            <Footer className="bg-[#f9fafb] border-t border-gray-300 p-3 flex items-center gap-3 flex-shrink-0">
              <Button
                type="text"
                icon={<PaperClipOutlined className="text-gray-400" />}
              />
              <Input
                placeholder="Type a message..."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                className="rounded-md text-black"
              />
              <Button
                type="primary"
                icon={<SendOutlined />}
                onClick={() => setMessage("")}
              />
            </Footer>
          )}
        </Content>
        {/* Right Info Panel */}
        {screens.md && (
          <Sider
            width={300}
            style={{
              background: "#f1f5f9",
              color: "#fff",
              height: "100vh",
              overflow: "hidden", 
            }}
          >
            {selectedChat ? (
              drawerUserInfo
            ) : (
              <Header className="bg-[#f1f5f9] flex items-center justify-between px-4 border-b border-gray-300 flex-shrink-0">
                <div className="flex items-center gap-3">
                  <Button
                    className="flex md:hidden"
                    type="text"
                    icon={<MenuOutlined />}
                    onClick={() => setDrawerVisible(true)}
                  />

                  <Text className="text-black text-lg font-semibold">
                    {selectedChat ? selectedChat.name : ""}
                  </Text>
                </div>
                {selectedChat && (
                  <Button
                    type="text"
                    icon={<InfoCircleOutlined className="text-gray-900" />}
                    className="md:hidden"
                    onClick={() => setUserDrawer(true)}
                  />
                )}
              </Header>
            )}
          </Sider>
        )}
        {!screens.md && (
          <Drawer
            placement="right"
            closable={false}
            onClose={() => setUserDrawer(false)}
            open={userDrawer}
            bodyStyle={{
              padding: 0,
              height: "100%",
            }}
            headerStyle={{ display: "none" }} 
          >
            {drawerUserInfo}
          </Drawer>
        )}
      </Layout>
    </Layout>
  );
};

export default AdminChats;

// import React, { useState } from "react";
// import {
//   Layout,
//   Input,
//   List,
//   Avatar,
//   Typography,
//   Button,
//   Divider,
//   Drawer,
//   Tooltip,
// } from "antd";
// import {
//   SendOutlined,
//   SearchOutlined,
//   PaperClipOutlined,
//   ArrowLeftOutlined,
//   MenuOutlined,
//   InfoCircleOutlined,
//   HomeOutlined,
//   NumberOutlined,
//   DownloadOutlined,
//   EditOutlined,
//   EllipsisOutlined,
// } from "@ant-design/icons";
// import { useNavigate } from "react-router-dom";
// import './adminchat.css'

// const { Sider, Content, Header, Footer } = Layout;
// const { Text, Title } = Typography;

// const AdminChats = () => {
//   const [selectedChat, setSelectedChat] = useState(null);
//   const [showInfo, setShowInfo] = useState(false);
//   const [message, setMessage] = useState("");
//   const [drawerVisible, setDrawerVisible] = useState(false);
//   const navigate = useNavigate();

//   const channels = [
//     {
//       id: 1,
//       name: "#General",
//       lastMessage: "Check incident log",
//       time: "10:42 AM",
//     },
//     {
//       id: 2,
//       name: "Data Analysis",
//       lastMessage: "Report uploaded",
//       time: "9:15 AM",
//     },
//     {
//       id: 3,
//       name: "Support Department",
//       lastMessage: "Ticket resolved",
//       time: "8:20 AM",
//     },
//   ];

//   const users = [
//     {
//       id: 4,
//       name: "Guest1",
//       lastMessage: "Check incident log",
//       time: "10:42 AM",
//     },
//     { id: 5, name: "Guest2", lastMessage: "Report uploaded", time: "9:15 AM" },
//     { id: 6, name: "Guest3", lastMessage: "Ticket resolved", time: "8:20 AM" },
//     { id: 7, name: "Guest4", lastMessage: "Ticket resolved", time: "8:20 AM" },
//     { id: 8, name: "Guest5", lastMessage: "Ticket resolved", time: "8:20 AM" },
//     { id: 9, name: "Guest6", lastMessage: "Ticket resolved", time: "8:20 AM" },
//   ];

//   const messages = [
//     {
//       id: 1,
//       sender: "guest-1234",
//       text: "Anna wants to connect.",
//       time: "2:00 PM",
//     },
//     {
//       id: 2,
//       sender: "mahmoud",
//       text: "Hello! Welcome to Dubai Chambers chat assistance. How may I help you today?",
//       time: "2:00 PM",
//     },
//     {
//       id: 3,
//       sender: "guest-1234",
//       text: "Hello there, do you prefer to chat with Arabic? I have an Arabic college here or it's ok in English.",
//       time: "2:01 PM",
//     },
//     {
//       id: 4,
//       sender: "mahmoud",
//       text: "I can chat in English or Arabic. Whichever suits you.",
//       time: "2:02 PM",
//     },
//     {
//       id: 5,
//       sender: "guest-1234",
//       text: "Ok nice, I prefer English.\n\nDear Sir,\n\nGreetings, I would like to inquire about a company named Musk Dubai for perfumes and cosmetics.",
//       time: "2:03 PM",
//     },
//   ];

//   const handleBack = () => setSelectedChat(null);

//   return (
//     <div className="h-screen flex flex-col md:flex-row bg-white">
//       {/* LEFT SIDEBAR */}
//       <div
//         className={`bg-[#000437] h-full w-full md:w-64 flex-shrink-0 flex flex-col transition-all duration-300 ${
//           selectedChat ? "hidden md:flex" : "flex"
//         }`}
//       >
//         <Header className="bg-[#000437]  px-4 border-b border-gray-700">
//           <div className="flex items-center justify-between">
//             <div>
//               <Avatar className="bg-blue-600 ">A</Avatar>
//             </div>
//             <div className="flex  items-center gap-4 text-sm">
//               <Tooltip title="Home">
//                 <HomeOutlined className="text-white" />
//               </Tooltip>
//               <Tooltip title="Search">
//                 <SearchOutlined className="text-white" />
//               </Tooltip>
//               <Tooltip title="Channels">
//                 <NumberOutlined className="text-white" />
//               </Tooltip>
//               <Tooltip title="Downloads">
//                 <DownloadOutlined className="text-white" />
//               </Tooltip>
//               <Tooltip title="Compose">
//                 <EditOutlined className="text-white" />
//               </Tooltip>
//               <Tooltip title="More">
//                 <EllipsisOutlined className="text-white" />
//               </Tooltip>
//             </div>
//           </div>
//         </Header>

//         <div className="bg-[#000437] flex items-center justify-between px-4 border-b border-gray-700">
//           <div className="flex items-center gap-2">
//             <Button
//               type="text"
//               icon={<ArrowLeftOutlined className="text-gray-300" />}
//               className="text-gray-300 md:hidden"
//               onClick={() => navigate("/react-dashboard")}
//             />
//             <Text className="text-gray-100 font-semibold text-lg">
//               Admin AAPA
//             </Text>
//           </div>
//           <Button
//             type="text"
//             icon={<MenuOutlined className="text-gray-300" />}
//           />
//         </div>

//         <div className="p-3">
//           <Input
//             prefix={<SearchOutlined className="text-gray-400" />}
//             placeholder="Search teams..."
//             className="rounded-md text-black border-none"
//           />
//         </div>

//         <div className="sidebar-scroll flex-1 overflow-y-auto ">
//           <div className="px-3">
//             <span className="text-gray-200 text-[12px]">Queued chats</span>
//           </div>
//           <List
//             itemLayout="horizontal"
//             dataSource={users}
//             renderItem={(item, idx) => (
//               <List.Item
//                 className={`hover:bg-[#003366] rounded-md cursor-pointer mb-1  transition ${
//                   selectedChat?.id === item.id ? "bg-[#003366]" : ""
//                 }`}
//                 onClick={() => setSelectedChat(item)}
//               >
//                 <List.Item.Meta
//                   avatar={
//                     <Avatar className="ml-2">{item.name.charAt(0)}</Avatar>
//                   }
//                   title={
//                     <span className="text-gray-100 font-medium">
//                       {item.name}
//                     </span>
//                   }
//                   // description={<span className="text-gray-400 text-sm">{item.lastMessage}</span>}
//                 />
//               </List.Item>
//             )}
//           />
//           <div className="px-3">
//             <span className="text-gray-200 text-[12px]">Channels</span>
//           </div>
//           <List
//             itemLayout="horizontal"
//             dataSource={channels}
//             renderItem={(item, idx) => (
//               <List.Item
//                 className={`hover:bg-[#003366] rounded-md cursor-pointer mb-1 p-2 transition ${
//                   selectedChat?.id === item.id ? "bg-[#003366]" : ""
//                 }`}
//                 onClick={() => setSelectedChat(item)}
//               >
//                 <List.Item.Meta
//                   avatar={
//                     <Avatar className="ml-2">
//                       {idx == 0 ? item.name.charAt(1) : item.name.charAt(0)}
//                     </Avatar>
//                   }
//                   title={
//                     <span className="text-gray-100 font-medium">
//                       {item.name}
//                     </span>
//                   }
//                   description={
//                     <span className="text-gray-400 text-sm">
//                       {item.lastMessage}
//                     </span>
//                   }
//                 />
//               </List.Item>
//             )}
//           />
//         </div>
//       </div>

//       {/* MIDDLE CHAT SECTION */}
//       <div
//         className={`flex-1 flex flex-col bg-white transition-all duration-300 ${
//           selectedChat ? "flex" : "hidden md:flex"
//         }`}
//       >
//         {/* Chat Header */}
//         <Header className="bg-[#f1f5f9] flex items-center justify-between px-4 border-b border-gray-300">
//           <div className="flex items-center gap-3">
//             <Button
//               type="text"
//               icon={<ArrowLeftOutlined className="text-gray-900" />}
//               className="text-gray-900 md:hidden"
//               onClick={handleBack}
//             />
//             <Text className="text-black text-lg font-semibold">
//               {selectedChat ? selectedChat.name : ""}
//             </Text>
//           </div>

//           {selectedChat && (
//             <Button
//               type="text"
//               icon={<InfoCircleOutlined className="text-gray-900" />}
//               className="md:hidden"
//               onClick={() => setShowInfo(true)}
//             />
//           )}
//         </Header>

//         {/* Chat Messages */}
//         <Content className="sidebar flex-1 overflow-y-auto p-6 space-y-5 bg-[#f1f5f9]">
//           {selectedChat ? (
//             <>
//               <div className="text-center text-gray-500 text-sm font-medium mt-2">
//                 Start of conversation
//                 <br />
//                 <span className="text-xs">July 8, 2025</span>
//               </div>

//               {messages.map((msg) => (
//                 <div key={msg.id} className="space-y-1">
//                   <div className="flex items-center justify-between">
//                     <Text className="text-gray-700 font-medium capitalize">
//                       {msg.sender}
//                     </Text>
//                     <Text className="text-gray-500 text-xs">{msg.time}</Text>
//                   </div>
//                   <div className="bg-white shadow-sm border border-gray-200 p-3 rounded-lg whitespace-pre-line text-gray-700">
//                     {msg.text}
//                   </div>
//                 </div>
//               ))}
//             </>
//           ) : (
//             <div className="h-full flex items-center justify-center text-gray-400">
//               Select a conversation from the left panel
//             </div>
//           )}
//         </Content>

//         {/* Message Input */}
//         {selectedChat && (
//           <Footer className="bg-[#f9fafb] border-t border-gray-300 p-3 flex items-center gap-3">
//             <Button
//               type="text"
//               icon={<PaperClipOutlined className="text-gray-400" />}
//             />
//             <Input
//               placeholder="Type a message..."
//               value={message}
//               onChange={(e) => setMessage(e.target.value)}
//               className="rounded-md text-black"
//             />
//             <Button
//               type="primary"
//               icon={<SendOutlined />}
//               onClick={() => setMessage("")}
//             />
//           </Footer>
//         )}
//       </div>

//       {/* RIGHT INFO PANEL */}
//       {selectedChat && (
//         <div
//           className={`fixed inset-0 z-50 bg-white shadow-lg w-full md:w-80 md:static md:translate-x-0 border-l border-gray-300 transition-transform duration-300 ${
//             showInfo ? "translate-x-0" : "translate-x-full md:translate-x-0"
//           }`}
//         >
//           {/* Header */}
//           <Header className="flex items-center justify-between px-4 py-3 border-b border-gray-300 bg-[#f1f5f9]">
//             <Text className="font-semibold text-gray-900 text-lg">
//               Room Information
//             </Text>
//             <Button
//               type="text"
//               className="text-gray-300 md:hidden"
//               icon={<ArrowLeftOutlined className="text-gray-300" />}
//               onClick={() => setShowInfo(false)}
//             />
//           </Header>

//           {/* Info Content */}
//           <div className="flex-1 overflow-y-auto p-5 space-y-5 text-gray-700">
//             {/* Contact */}
//             <div>
//               <Text className="text-gray-900 font-semibold block mb-1">
//                 Contact
//               </Text>
//               <div className="flex items-center gap-2">
//                 <Avatar>A</Avatar>
//                 <Text>Anna (guest-1234)</Text>
//               </div>
//             </div>

//             <Divider />

//             {/* Agent */}
//             <div>
//               <Text className="text-gray-900 font-semibold block mb-1">
//                 Agent
//               </Text>
//               <div className="flex items-center gap-2">
//                 <Avatar>M</Avatar>
//                 <div>
//                   <Text className="block text-gray-800">Maani (mahmoud)</Text>
//                   <Text className="block text-gray-500 text-sm">
//                     Department: DC_AGENT_EN
//                   </Text>
//                 </div>
//               </div>
//             </div>

//             <Divider />

//             {/* Details */}
//             <div>
//               <Text className="block text-gray-500 text-sm">Queue Time</Text>
//               <Text className="text-gray-800">A few seconds</Text>
//             </div>

//             <div>
//               <Text className="block text-gray-500 text-sm">Created At</Text>
//               <Text className="text-gray-800">July 8, 2025, 2:00 PM</Text>
//             </div>

//             <div>
//               <Text className="block text-gray-500 text-sm">Taken At</Text>
//               <Text className="text-gray-800">July 8, 2025, 2:00 PM</Text>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default AdminChats;
